import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

// 引入组件
import MembersIntro from '../membersIntro/';

class FrameWork extends React.PureComponent {

    render() {
        const { content } = this.props;

        return (
            <div id="framework" className={styles.frameWork}>
                <h3>组织架构</h3>
                <img src={content.framePic} className={styles.framePic} />
                <div className={styles.members}>
                    <MembersIntro content={content} />
                </div>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
FrameWork.propTypes = { content: PropTypes.string };

/**
 * 定义组件默认属性
 * */
FrameWork.defaultProps = {};

export default FrameWork;
